export const emptyProgramText = {
    NoContent: {
        en: "No Content Found!",
        mr: "कोणतीही सामग्री आढळली नाही!",
    },
    Message: {
        en: "There is currently no content available for you.",
        mr: "सध्या तुमच्यासाठी कोणताही आशय उपलब्ध नाही.",
    },
    GoBack: {
        en: "Go back",
        mr: "परत जा",
    },
};
